import ListTwoTicketDetails from './ListTwoTicketDetails';
import ListTwoTicketStudies from './ListTwoTicketStudies';

export { default } from './ListTwo';
export { ListTwoTicketDetails, ListTwoTicketStudies };
